<template>
  <v-container fluid>
    <v-toolbar color="primary" dark>
      <v-toolbar-title dark>Активист</v-toolbar-title>
      <template v-slot:extension>
        <v-tabs fixed-tabs color="primary" active-class="active-tab">
          <v-tabs-slider color="#FDE700"></v-tabs-slider>
          <v-tab
            ref="tasks"
            key="activist_tasks"
            dark
            color="#FDE700"
            :to="{ name: 'activist_tasks' }"
            >Задания
          </v-tab>
          <!--          <v-tab ref="courses" key="courses_list" dark color="#FDE700" :to="{ name: 'hps_course' }"-->
          <!--            >Курсы-->
          <!--          </v-tab>-->
          <!--          <v-tab key="hps_teachers_list" :to="{ name: 'hps_teacher' }"> Преподаватели </v-tab>-->
        </v-tabs>
      </template>
    </v-toolbar>
    <v-col>
      <router-view name="activist" />
    </v-col>
  </v-container>
</template>

<script>
export default {
  name: 'ActivistIndex',
}
</script>
